import { createChatShortLinkByVendorId, getChatShortLink } from '@/services/chat.service';
import { isLogined, createAccountByToken } from '@/services/mallUser.service';
import { useEffect, useMemo, useState } from 'react';
import { useAnonymousUserStore, useUserStore } from '@/store/userStore';
import { useParams, useRevalidator, useRouteLoaderData } from 'react-router-dom';
import { vendorStore } from '@/store/vendorStore';
import { getVendorByPath } from '@/services/matching.service';
import config from '@/config/config';
import { Box } from '@mui/material';
import { toast } from 'react-toastify';
import { getTokenByAnonymous } from '@/services/auth.service';
import { axiosApi } from '@/helpers/api.helper';

export default function ChatTestIframe({ targetId, setOpen }: { targetId?: string; setOpen: Function }) {
    const { productId = '', vendorPath = '' } = useParams();
    // 우선 라우터 로더 데이터에서 시도
    const loaderData = useRouteLoaderData('vendorRoute') as any;
    const initialVendorId: string | null = loaderData?.vendor?.id || vendorStore.getState().vendor?.id || null;
    const [vendorId, setVendorId] = useState<string | null>(initialVendorId);

    const revalidate = useRevalidator();
    const { path = '' } = useParams() as any;
    const targetProductId = !!targetId ? targetId : productId;
    const userId = useUserStore.getState().mallUserId;
    const anonymousId = useAnonymousUserStore.getState().mallUserId;
    const [shortLink, setShortLink] = useState<string | null>(null);

    // vendorId가 없으면 params 기반으로 조회하여 보완
    useEffect(() => {
        if (vendorId) return;
        (async () => {
            try {
                if (!vendorPath) return;
                const list = await getVendorByPath({ vendorPath });
                const v = Array.isArray(list) ? list[0] : null;
                if (v?.id) {
                    vendorStore.getState().setVendor(v);
                    setVendorId(v.id);
                }
            } catch (e) {
                // ignore; 아래 effect에서 에러 메시지 처리
            }
        })();
    }, [vendorId, vendorPath]);
    async function iframeLoginFunc(event: MessageEvent<any>) {
        if (event.data === 'login') {
            console.log('login');
            revalidate.revalidate();
        }
    }
    async function iframeLogOutFunc(event: MessageEvent<any>) {
        if (event.data === 'logout') {
            console.log('logout');
            setOpen(false);
            const checkPage =
                window.location.href.includes('order-n-shipping-info') ||
                window.location.href.includes('order-detail-info') ||
                window.location.href.includes('pay-result');
            if (!!checkPage) {
                window.location.href = `${config.api.flowing_spacehome_url}/mall/${path}`;
            } else {
                revalidate.revalidate();
            }
        }
    }
    useEffect(() => {
        (async () => {
            try {
                if (!vendorId) {
                    toast.error('채팅방 정보를 불러오는 중 문제가 발생했습니다. 새로고침 후 다시 시도해주세요.');
                    setShortLink(null);
                    setOpen(false);
                    return;
                }
                let currentAnonymousId = anonymousId;

                // 로그인하지 않았고 anonymousId가 없는 경우 생성
                if (!isLogined() && !currentAnonymousId) {
                    const { access_token } = await getTokenByAnonymous();
                    axiosApi.defaults.headers.common.Authorization = `Bearer ${access_token}`;
                    const { mallUserId } = await createAccountByToken(access_token);
                    useAnonymousUserStore.setState({
                        mallUserId,
                        accessToken: access_token,
                    });
                    currentAnonymousId = mallUserId;
                }

                await createChatShortLinkByVendorId({
                    userId: isLogined() ? userId : currentAnonymousId,
                    vendorId: vendorId,
                })
                    .then((r) => {
                        setShortLink(`${config.url.chatting_url}/qna/${r.data?.shortLink || ''}`);
                        return r;
                    })
                    .catch(() => {
                        toast.error('채팅방 정보를 불러오는 중 문제가 발생했습니다. 새로고침 후 다시 시도해주세요.');
                        setShortLink(null);
                        setOpen(false);
                    });
            } catch (error) {
                toast.error('채팅방 정보를 불러오는 중 문제가 발생했습니다. 새로고침 후 다시 시도해주세요.');
                setShortLink(null);
                setOpen(false);
            }
        })();
    }, [isLogined(), targetProductId, vendorId]);
    useEffect(() => {
        if (isLogined()) return;
        window.addEventListener('message', iframeLoginFunc);
        return () => {
            console.log('%c iframe is unmounted', 'color:red;font-weight:bold;');
            window.removeEventListener('message', iframeLoginFunc);
        };
    }, [isLogined()]);
    useEffect(() => {
        if (!isLogined()) return;
        window.addEventListener('message', iframeLogOutFunc);
        return () => {
            console.log('%c iframe is unmounted', 'color:red;font-weight:bold;');
            window.removeEventListener('message', iframeLogOutFunc);
        };
    }, [isLogined()]);

    return (
        <>
            {shortLink && (
                <Box
                    component="iframe"
                    sx={{
                        width: '100%',
                        height: '100%',
                        border: 'none',
                    }}
                    src={`${shortLink}`}
                />
            )}
        </>
    );
}
